import React, { useMemo, useState } from "react";
import objectPath from "object-path";
import { NavLink, OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { checkIsActive, toAbsoluteUrl } from "../../../_helpers";
import { LanguageSelectorDropdown } from "../extras/dropdowns/LanguageSelectorDropdown";
import { QuickUserToggler } from "../extras/QuickUserToggler";
import { Brand } from "../brand/Brand";
import { Link, useLocation } from "react-router-dom";
import helperFunc from "../../../_helpers/helperFunc";

export function Aside() {
  const uiService = useHtmlClassService();
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
      : "";
  };

  const layoutProps = useMemo(() => {
    return {
      asideClassesFromConfig: uiService.getClasses("aside", true),
      layoutConfig: uiService.config,
      asideMenuAttr: uiService.getAttributes("aside_menu"),
      ulClasses: uiService.getClasses("aside_menu_nav", true),
      asideMenuClassesFromConfig: uiService.getClasses("aside_menu", true),
      asideSecondaryDisplay: objectPath.get(
        uiService.config,
        "aside.secondary.display"
      ),
      asideSelfMinimizeToggle: objectPath.get(
        uiService.config,
        "aside.self.minimize.toggle"
      ),
      extrasSearchDisplay: objectPath.get(
        uiService.config,
        "extras.search.display"
      ),
      extrasNotificationsDisplay: objectPath.get(
        uiService.config,
        "extras.notifications.display"
      ),
      extrasQuickActionsDisplay: objectPath.get(
        uiService.config,
        "extras.quick-actions.display"
      ),
      extrasQuickPanelDisplay: objectPath.get(
        uiService.config,
        "extras.quick-panel.display"
      ),
      extrasLanguagesDisplay: objectPath.get(
        uiService.config,
        "extras.languages.display"
      ),
      extrasUserDisplay: objectPath.get(
        uiService.config,
        "extras.user.display"
      ),
    };
  }, [uiService]);

  return (
    <>
      {/* begin::Aside */}
      <div
        id="kt_aside"
        // className={`aside aside-left d-flex ${layoutProps.asideClassesFromConfig}`}
        className={`aside aside-left aside-d-none ${layoutProps.asideClassesFromConfig}`}
      >
        {/* begin::Primary */}
        <div className="aside-primary d-flex flex-column align-items-center flex-row-auto">
          <Brand />
          {/* begin::Nav Wrapper */}
          <div className="aside-nav d-flex flex-column align-items-center flex-column-fluid w-100 py-1 scroll scroll-pull">
            <div id="kt_aside_menu" className="aside-menu w-100">
              <ul className={`menu-nav ${layoutProps.ulClasses}`}>
                {/* {helperFunc.isButtonAccess("dashborad.home.list") && (
                  <li
                    className={`menu-item  ${getMenuItemActive("/dashboard")}`}
                    onClick={() => window.location.reload()}
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={<Tooltip id="latest-project">Dashboard</Tooltip>}
                    >
                      <Link
                        className="menu-link nav-link btn btn-icon btn-clean btn-lg my-menu-item"
                        to="/dashboard"
                      >
                        <span className="svg-icon svg-icon-lg menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Layout/Layout-4-blocks.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Dashboard</span>
                      </Link>
                    </OverlayTrigger>
                  </li>
                )} */}

                {/* {roles and permissions} */}
                {helperFunc.isButtonAccess("roleandpermission.module.list") && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">
                          Roles and Permission
                        </Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/role-and-permissions"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Communication/Group.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Roles and Permission</span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>
                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {/* {roles and permissions -> Module} */}
                        {helperFunc.isButtonAccess(
                          "roleandpermission.module.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/role-and-permissions/module"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">Modules</Tooltip>
                              }
                            >
                              <Link
                                to={"/role-and-permissions/module"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Group.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Modules</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                      
                        {false && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/role-and-permissions/roles"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">Roles</Tooltip>
                              }
                            >
                              <Link
                                to={"/role-and-permissions/roles"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Group.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Roles</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                      </ul>
                    </div>
                  </li>
                )}
                {/* {General Settings} */}
                {(helperFunc.isButtonAccess("general.banners.list") ||
                  helperFunc.isButtonAccess("general.levels.list") ||
                  helperFunc.isButtonAccess("general.pointCategories.list") ||
                  helperFunc.isButtonAccess("general.points.list") ||
                  helperFunc.isButtonAccess("general.liveStreaming.list") ||
                  helperFunc.isButtonAccess("general.avatarCategories.list") ||
                  helperFunc.isButtonAccess("general.avatars.list") ||
                  helperFunc.isButtonAccess("general.generalSetting.list")) && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={<Tooltip id="latest-project">General</Tooltip>}
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/customer-care"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/General/Settings-2.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">General</span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>

                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {helperFunc.isButtonAccess("general.banners.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/banners"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">Banners</Tooltip>
                              }
                            >
                              <Link
                                to={"/banners"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Home/Picture.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Banners</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                          // )} {helperFunc.isMenuShow('userBanners') && (
                          //   <li className={`menu-item  ${getMenuItemActive("/user-banners")}`} aria-haspopup="true">
                          //     <OverlayTrigger
                          //       placement="right"
                          //       overlay={<Tooltip id="latest-reports">User Banners</Tooltip>}
                          //     >
                          //       <Link to={'/user-banners'} className="menu-link nav-link btn btn-icon btn-clean btn-lg" role="tab">
                          //         <span className="svg-icon svg-icon-lg menu-icon">
                          //           <SVG src={toAbsoluteUrl("/media/svg/icons/Files/User-folder.svg")} />
                          //         </span>
                          //         <span className="menu-text">User Banners</span>
                          //       </Link>
                          //     </OverlayTrigger>
                          //   </li>
                        )}
                        {helperFunc.isButtonAccess("general.levels.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/levels"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">Levels</Tooltip>
                              }
                            >
                              <Link
                                to={"/levels"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  {/* <SVG src={toAbsoluteUrl("/media/svg/icons/Home/Ladder.svg")} /> */}
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/General/Star.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Levels</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess(
                          "general.pointCategories.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/point-categories"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Point Categories
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/point-categories"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Clipboard-list.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Point Categories
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess("general.points.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/points"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">Points</Tooltip>
                              }
                            >
                              <Link
                                to={"/points"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Clipboard-list.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Points</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                          // )} {helperFunc.isMenuShow('medals') && (
                          //   <li className={`menu-item  ${getMenuItemActive("/medals")}`} aria-haspopup="true">
                          //     <OverlayTrigger
                          //       placement="right"
                          //       overlay={<Tooltip id="latest-reports">Medals</Tooltip>}
                          //     >
                          //       <Link to={'/medals'} className="menu-link nav-link btn btn-icon btn-clean btn-lg" role="tab">
                          //         <span className="svg-icon svg-icon-lg menu-icon">
                          //           <SVG src={toAbsoluteUrl("/media/svg/icons/General/Star.svg")} />
                          //         </span>
                          //         <span className="menu-text">Medals</span>
                          //       </Link>
                          //     </OverlayTrigger>
                          //   </li>
                        )}
                        {helperFunc.isButtonAccess(
                          "general.liveStreaming.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/live-streaming"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">Pages</Tooltip>
                              }
                            >
                              <Link
                                to={"/live-streaming"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Text/Bullet-list.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Live Streaming
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess(
                          "general.avatarCategories.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/avatar-categories"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Avatar Categories
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/avatar-categories"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/General/User.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Avatar Categories
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess("general.avatars.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/avatars"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">Avatars</Tooltip>
                              }
                            >
                              <Link
                                to={"/avatars"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/General/User.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Avatars</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess(
                          "general.generalSetting.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/general/settings"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  General Settings
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/general/settings"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/General/Settings-2.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  General Settings
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                      </ul>
                    </div>
                  </li>
                )}
                {/* {Affiliate Program} */}
                {helperFunc.isButtonAccess(
                  "affiliateprogram.affiliateprogram.list"
                ) && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/affiliateprogram"
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">Affiliate Program</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/affiliateprogram"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/General/Like.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Affiliate Program</span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>
                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {/* {helperFunc.isButtonAccess(
                          "advertisers.advertisers.list"
                        ) && ( */}
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/affiliateprogram/list"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                Affiliate Program List
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/affiliateprogram/list"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/General/Like.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                Affiliate Program List
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                        {/* )} */}
                        {/* {helperFunc.isButtonAccess(
                          "advertisers.advertisers.add"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/sponsors/create"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  New Advertisers
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/sponsors/create"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/General/Like.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  New Advertisers
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )} */}
                      </ul>
                    </div>
                  </li>
                )}
                {/* {Advertisers} */}
                {(helperFunc.isButtonAccess("advertisers.advertisers.list") ||
                  helperFunc.isButtonAccess("advertisers.advertisers.add")) && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/sponsors"
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">Advertisers</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/sponsors"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/General/Like.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Advertisers</span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>
                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {helperFunc.isButtonAccess(
                          "advertisers.advertisers.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/sponsors/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Advertisers List
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/sponsors/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/General/Like.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Advertisers List
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess(
                          "advertisers.advertisers.add"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/sponsors/create"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  New Advertisers
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/sponsors/create"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/General/Like.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  New Advertisers
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                      </ul>
                    </div>
                  </li>
                )}
                {/* Blogs */}
                {helperFunc.isButtonAccess("blogs.blog.list") && (
                  <li
                    className={`menu-item mb-3 ${getMenuItemActive("/blogs")}`}
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={<Tooltip id="latest-project">Blogs</Tooltip>}
                    >
                      <Link
                        className="menu-link nav-link btn btn-icon btn-clean btn-lg my-menu-item"
                        to="/blogs"
                      >
                        <span className="svg-icon svg-icon-lg menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Text/Menu.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Blogs</span>
                      </Link>
                    </OverlayTrigger>
                  </li>
                )}
                {/* Reports */}
                {(helperFunc.isButtonAccess("reports.MarketingReport.list") ||
                  helperFunc.isButtonAccess("ampere.dashboard.list") ||
                  helperFunc.isButtonAccess("ampere.contestReport.list") ||
                  helperFunc.isButtonAccess("reports.ooredoopowerplay.list") ||
                  helperFunc.isButtonAccess(
                    "reports.LeadgerSummaryReport.list"
                  ) ||
                  helperFunc.isButtonAccess("reports.usersReports.list") ||
                  helperFunc.isButtonAccess("reports.loginLog.list") ||
                  helperFunc.isButtonAccess("reports.usersGameReports.list") ||
                  helperFunc.isButtonAccess(
                    "reports.usersWalletReports.list"
                  ) ||
                  helperFunc.isButtonAccess(
                    "reports.usersLeaderboardReports.list"
                  ) ||
                  helperFunc.isButtonAccess("reports.GST.list") ||
                  helperFunc.isButtonAccess(
                    "reports.cashfreeTransactions.list"
                  ) ||
                  helperFunc.isButtonAccess(
                    "reports.withdrawalsRequestReport.list"
                  ) ||
                  helperFunc.isButtonAccess("reports.buyCoins.list") ||
                  helperFunc.isButtonAccess("reports.buyBundles.list") ||
                  helperFunc.isButtonAccess(
                    "reports.businessDailyReports.list"
                  ) ||
                  helperFunc.isButtonAccess("reports.CRM.list") ||
                  helperFunc.isButtonAccess("reports.contestReports.list") ||
                  helperFunc.isButtonAccess(
                    "reports.gamerjiallcontestReports.list"
                  ) ||
                  helperFunc.isButtonAccess(
                    "reports.allReportsDownload.list"
                  ) ||
                  helperFunc.isButtonAccess(
                    "reports.gamerjiTournamentReports.list"
                  ) ||
                  helperFunc.isButtonAccess("reports.ledgerReport.list") ||
                  helperFunc.isButtonAccess("reports.retentionReports.list") ||
                  helperFunc.isButtonAccess(
                    "reports.userGameLeaderboardReports.list"
                  ) ||
                  helperFunc.isButtonAccess(
                    "reports.userDailyGameReports.list"
                  ) ||
                  helperFunc.isButtonAccess(
                    "reports.walletSummaryReports.list"
                  ) ||
                  helperFunc.isButtonAccess(
                    "reports.usersPurchasedReports.list"
                  ) ||
                  helperFunc.isButtonAccess(
                    "reports.usersRedeemRewardsReports.list"
                  ) ||
                  helperFunc.isButtonAccess(
                    "reports.joinTournamentOnMobile.list"
                  ) ||
                  helperFunc.isButtonAccess("reports.loginLogOnMobile.list") ||
                  helperFunc.isButtonAccess("reports.allnewcompanydashboardlist.list") ||
                  helperFunc.isButtonAccess("reports.appFlyerReports.list") ||
                  helperFunc.isButtonAccess('reports.companydashboardlist.list') ||
                  helperFunc.isButtonAccess("reports.requestLog.list")) && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={<Tooltip id="latest-project">Reports</Tooltip>}
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/customer-care"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/General/Settings-2.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Reports</span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>
                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                            {helperFunc.isButtonAccess(
                          "reports.allnewcompanydashboardlist.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/allnewreports"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                 All Company Dashboard
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/allnewreports"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Clipboard-list.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                               All Company Dashboard
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess(
                          "reports.MarketingReport.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/reports/MarketingReport"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Marketing Report
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/reports/MarketingReport"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Clipboard-list.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Marketing Report
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                      
                        {helperFunc.isButtonAccess(
                          "reports.LeadgerSummaryReport.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/reports/LeadgerSummaryReport"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Ledger Summary Report
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/reports/LeadgerSummaryReport"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Clipboard-list.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Ledger Summary Report
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess("reports.GST.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/reports/gst"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">GST</Tooltip>
                              }
                            >
                              <Link
                                to={"/reports/gst"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Clipboard-list.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">GST</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {/* {helperFunc.isButtonAccess(
                          "reports.usersReports.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/reports/users"
                            )}`}
                            aria-haspopup="true"
                          >
                            <Link
                              to={"/reports/users"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Clipboard-list.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">Users Reports</span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                      )}
                      {helperFunc.isButtonAccess("reports.loginLog.list") && (
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/reports/loginlogs"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                Login Log's Report
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/reports/loginlogs"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Clipboard-list.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                Login Log's Report
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                      )}
                      {helperFunc.isButtonAccess(
                        "reports.usersGameReports.list"
                      ) && (
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/reports/user-game"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                Users Game Reports
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/reports/user-game"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Clipboard-list.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                Users Game Reports
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                      )}
                      {helperFunc.isButtonAccess(
                        "reports.usersWalletReports.list"
                      ) && (
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/reports/user-coin"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                Users Wallet Reports
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/reports/user-coin"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Clipboard-list.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                Users Wallet Reports
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                      )}
                      {helperFunc.isButtonAccess(
                        "reports.usersLeaderboardReports.list"
                      ) && (
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "user-leaderboard"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                User Leaderboard Reports
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/reports/user-leaderboard"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Clipboard-list.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                {" "}
                                User Leaderboard Reports
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                      )}
                      {helperFunc.isButtonAccess("reports.GST.list") && (
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/reports/gst"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">GST</Tooltip>
                            }
                          >
                            <Link
                              to={"/reports/gst"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Clipboard-list.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">GST</span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                      )}
                      {helperFunc.isButtonAccess(
                        "reports.cashfreeTransactions.list"
                      ) && (
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/reports/cashfree-transactions"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                Cashfree Transactions
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/reports/cashfree-transactions"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Clipboard-list.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                Cashfree Transactions
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                      )}
                      {helperFunc.isButtonAccess(
                        "reports.withdrawalsRequestReport.list"
                      ) && (
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/reports/withdrawals-request"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                Withdrawals Request Reports
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/reports/withdrawals-request"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Clipboard-list.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                Withdrawals Request Reports
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                      )}
                      {helperFunc.isButtonAccess("reports.buyCoins.list") && (
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/reports/buy-coins"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">Buy Coins</Tooltip>
                            }
                          >
                            <Link
                              to={"/reports/buy-coins"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Clipboard-list.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">Buy Coins</span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                      )}
                      {helperFunc.isButtonAccess(
                        "reports.buyBundles.list"
                      ) && (
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/reports/buy-bundles"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                Buy Bundles
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/reports/buy-bundles"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Clipboard-list.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">Buy Bundles</span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                      )}
                      {helperFunc.isButtonAccess(
                        "reports.businessDailyReports.list"
                      ) && (
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/reports/business-daily"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                Business Daily Reports
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/reports/business-daily"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <Link
                                to={"/reports/business-daily"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Clipboard-list.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Business Daily Reports
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )} */}
                        {helperFunc.isButtonAccess("reports.CRM.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/reports/crm"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">CRM</Tooltip>
                              }
                            >
                              <Link
                                to={"/reports/crm"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Clipboard-list.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">CRM </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess(
                          "reports.allReportsDownload.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/reports/DownloadReport"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="download-report">
                                  All Reports Download
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/reports/DownloadReport"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Clipboard-list.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  All Reports Download's
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {/* 
                       
                        {helperFunc.isButtonAccess(
                          "reports.logsDownload.list" ///need to add this module in report module
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/reports/logReportDownload"
                            )}`}
                            aria-haspopup="true"
                          >
                            <Link
                              to={"/reports/logReportDownload"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Clipboard-list.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                Log Reports Download
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                      )}
                      {helperFunc.isButtonAccess(
                        "reports.allTimeRetentionReports.list"
                      ) && (
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/reports/all-time-retention"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="retention-reports">
                                All Time Retention Reports
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/reports/all-time-retention"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <Link
                                to={"/reports/all-time-retention"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Clipboard-list.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  All Time Retention Reports
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )} */}
                        {helperFunc.isButtonAccess(
                          "reports.contestReports.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/contests/contests-reports"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Contest's Reports
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/contests/contests-reports"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Shopping/Settings.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Contest's Reports
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}{" "}
                        {helperFunc.isButtonAccess(
                          "reports.gamerjiallcontestReports.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/contests/gamerji-all-contests-reports"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Gamerji All Contest Report
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/contests/gamerji-all-contests-reports"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Shopping/Settings.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Gamerji All Contest Report
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}{" "}
                        {helperFunc.isButtonAccess(
                          "reports.ooredoopowerplay.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/oreedoo-contests/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Ooredoo-PowerPlay Contest's
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/oreedoo-contests/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Shopping/Settings.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Ooredoo-PowerPlay Contest's
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess(
                          "reports.gamerjiTournamentReports.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/tournaments/gamerji/report"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Gamerji Tournament's Reports
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/tournaments/gamerji/report"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Shopping/Settings.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Gamerji Tournament's Reports
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}{" "}
                        {/* {helperFunc.isButtonAccess(
                          "reports.ledgerReport.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/reports/users-ledger"
                            )}`}
                            aria-haspopup="true"
                          >
                            <Link
                              to={"/reports/users-ledger"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Clipboard-list.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">Ledger Report</span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                      )}
                      {helperFunc.isButtonAccess(
                        "reports.retentionReports.list"
                      ) && (
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/reports/overall-retention"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                Retention Reports
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/reports/overall-retention"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Clipboard-list.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                Retention Reports
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                      )}
                      {helperFunc.isButtonAccess(
                        "reports.retentionReports.list"
                      ) && (
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/reports/retention"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">Retention</Tooltip>
                            }
                          >
                            <Link
                              to={"/reports/retention"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Clipboard-list.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">Retention</span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                      )}
                      {helperFunc.isButtonAccess(
                        "reports.userGameLeaderboardReports.list"
                      ) && (
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/reports/user-game-leaderboard"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                User Game Leaderboard Reports
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/reports/user-game-leaderboard"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Clipboard-list.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                User Game Leaderboard Reports
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                      )}
                      {helperFunc.isButtonAccess(
                        "reports.userDailyGameReports.list"
                      ) && (
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/reports/user-daily-game"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                User Daily Game
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/reports/user-daily-game"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Clipboard-list.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                User Daily Game
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                      )}
                      {helperFunc.isButtonAccess(
                        "reports.walletSummaryReports.list"
                      ) && (
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/reports/wallet-summary"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                Wallet Summary Reports
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/reports/wallet-summary"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Clipboard-list.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                Wallet Summary Reports
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                      )}
                      {helperFunc.isButtonAccess(
                        "reports.usersPurchasedReports.list"
                      ) && (
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/reports/UsersPurched"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="download-report">
                                User's Purched Report's
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/reports/UsersPurched"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Clipboard-list.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                User's Purched Report's
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                      )}
                      {helperFunc.isButtonAccess(
                        "reports.joinedPaidGameReports.list"
                      ) && (
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/reports/JoinPaidGame"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="download-report">
                                Joined Paid Game Report's
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/reports/JoinPaidGame"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Clipboard-list.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                Joined Paid Game Report's
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                      )}
                      {helperFunc.isButtonAccess(
                        "reports.usersRedeemRewardsReports.list"
                      ) && (
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/reports/UsersRedeemrewards"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="download-report">
                                Users Redeem rewards Report's
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/reports/UsersRedeemrewards"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Clipboard-list.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                Users Redeem rewards Report's
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                      )}
                      {helperFunc.isButtonAccess(
                        "reports.requestLog.list"
                      ) && (
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/reports/request-call"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                Request Log Reports
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/reports/request-call"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Clipboard-list.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                Request Log Reports
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                      )}
                      {helperFunc.isButtonAccess(
                        "reports.appFlyerReports.list"
                      ) && (
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/reports/app-flyer"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="app-flyer">
                                App Flyer Reports
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/reports/app-flyer"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Clipboard-list.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                App Flyer Reports
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                      )}
                      {helperFunc.isButtonAccess(
                        "reports.loginLogOnMobile.list"
                      ) && (
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/reports/user-login-report"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                User Login Report - OnMobile
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/reports/user-login-report"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Clipboard-list.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                User Login Report - OnMobile
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                      )}
                      {helperFunc.isButtonAccess(
                        "reports.joinTournamentOnMobile.list"
                      ) && (
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/reports/user-join-tournament-report"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                User Join Tournament Report - OnMobile
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/reports/user-join-tournament-report"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <Link
                                to={"/reports/user-join-tournament-report"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Clipboard-list.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  User Join Tournament Report - OnMobile
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )} */}
                      </ul>
                    </div>
                  </li>
                )}
                {/* user */}
                {(helperFunc.isButtonAccess("users.staffs.list") ||
                  helperFunc.isButtonAccess("users.appusers.list") ||
                  helperFunc.isButtonAccess("user.hackers.list") ||
                  helperFunc.isButtonAccess("user.deleteRequest.list")) && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={<Tooltip id="latest-project">Users</Tooltip>}
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/users"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Communication/Group.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Users</span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>

                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {helperFunc.isButtonAccess("users.staffs.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/users/staff-user"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">Staffs</Tooltip>
                              }
                            >
                              <Link
                                to={"/users/staff-user"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Group.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Staffs</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess("users.appusers.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/users/app-users"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  App User's
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/users/app-users"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/General/User.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">App User's</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}

                        {helperFunc.isButtonAccess("user.hackers.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/users/hackerlist"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">Hackers</Tooltip>
                              }
                            >
                              <Link
                                to={"/users/hackerlist"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/General/User.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Hackers</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess(
                          "user.deleteRequest.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/users/delete-request"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  User Delete Request
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/users/delete-request"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/General/User.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  User Delete Request
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                      </ul>
                    </div>
                  </li>
                )}
                {/* game */}
                {(helperFunc.isButtonAccess("game.games.list") ||
                  helperFunc.isButtonAccess("game.PBL.update") ||
                  helperFunc.isButtonAccess("game.PBE.update") ||
                  helperFunc.isButtonAccess("game.FTS.update")) && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={<Tooltip id="latest-project">Game</Tooltip>}
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/games/list"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Shopping/Settings.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Game </span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>

                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {helperFunc.isButtonAccess("game.games.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/games/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">Games</Tooltip>
                              }
                            >
                              <Link
                                to={"/games/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Games</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}

                        {helperFunc.isButtonAccess("game.games.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/games/casualgame-list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">Casual Game</Tooltip>
                              }
                            >
                              <Link
                                to={"/games/casualgame-list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Casual Game</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}

                        {helperFunc.isButtonAccess("game.PBL.update") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/external-platform/game/edit-game/PBL"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">Peel Blue</Tooltip>
                              }
                            >
                              <Link
                                to={"/external-platform/game/edit-game/PBL"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Peel Blue</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}

                        {helperFunc.isButtonAccess("game.PBE.update") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/external-platform/game/edit-game/PBE"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">Pear Bee</Tooltip>
                              }
                            >
                              <Link
                                to={"/external-platform/game/edit-game/PBE"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Pear Bee</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}

                        {helperFunc.isButtonAccess("game.FTS.update") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/external-platform/game/edit-game/FTS"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">Pear Bee</Tooltip>
                              }
                            >
                              <Link
                                to={"/external-platform/game/edit-game/FTS"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Fantasy E-Sports
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}

                        {/* <li
                          className={`menu-item  ${getMenuItemActive(
                            "/game-types/list"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                Game Type
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/game-types/list"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Add-user.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                Game Type
                                <i className='flaticon2-check-mark text-success ml-2 font-size-lg'></i>
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li> */}
                      </ul>
                    </div>
                  </li>
                )}
                {/* temporaryy casual contest */}
                  {(helperFunc.isButtonAccess("casual.contest.list") ||
              
                  helperFunc.isButtonAccess(
                    "casual.contest.list"
                  )) && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={<Tooltip id="latest-project">Casual Contests</Tooltip>}
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/casualcontests"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Shopping/Settings.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Casual Contests </span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>

                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                  
                        {helperFunc.isButtonAccess("contest.contests.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/casualcontests/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                 Casual Contest's List
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/casualcontests/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Shopping/Settings.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                 Casual Contest's List{" "}
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                  
                      </ul>
                    </div>
                  </li>
                )} 
                {/* 16-01 */}
                {/* contest */}
                {(helperFunc.isButtonAccess("contest.contests.list") ||
                  helperFunc.isButtonAccess("contest.contestsboard.list") ||
                  helperFunc.isButtonAccess("contest.assignShortlink.list") ||
                  helperFunc.isButtonAccess("contest.contestsboard.list") ||
                  helperFunc.isButtonAccess("contest.fullContestList.other") ||
                  helperFunc.isButtonAccess("contest.assignContestList.list") ||
                  helperFunc.isButtonAccess(
                    "contest.reAssignContestList.list"
                  )) && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={<Tooltip id="latest-project">Contests</Tooltip>}
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/contests"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Shopping/Settings.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Contests </span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>

                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {/* {helperFunc.isMenuShow("contestTypes") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/contest-types/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Contest's Type
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/contest-types/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Clipboard-list.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Contest's Type <i className='flaticon2-check-mark text-success ml-2 font-size-lg'></i></span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}{" "} */}
                        {helperFunc.isButtonAccess("contest.contests.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/contests/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Contest's List
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/contests/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Shopping/Settings.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Contest's List{" "}
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess(
                          "contest.assignShortlink.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/contest-assign-shortlink/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Contest Assign ShortLink
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/contest-assign-shortlink/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Shopping/Settings.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Contest Assign ShortLink{" "}
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {/* {helperFunc.isMenuShow("contest.report.") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/contests/contests-reports"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Contest's Reports
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/contests/contests-reports"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Shopping/Settings.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Contest's Reports
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}{" "} */}
                        {/* {helperFunc.isMenuShow("contest") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/contests/user-list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Contest's User's List
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/contests/user-list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Shopping/Settings.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Contest's User's List
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}{" "} */}
                        {/* {helperFunc.isMenuShow("auditContests") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/contests/transactions"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Contest's Transactions
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/contests/transactions"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Shopping/Settings.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Contest's Transactions
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}{" "} */}
                        {helperFunc.isButtonAccess(
                          "contest.assignContestList.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/contest-assign/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Assign / Reassign Contest's
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/contest-assign/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Contest Assign
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess(
                          "contest.reAssignContestList.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/contest-assign/reassign"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  ReAssign Contest
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/contest-assign/reassign"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Contest ReAssign
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {(helperFunc.isButtonAccess(
                          "contest.contestsboard.list"
                        ) ||
                          helperFunc.isButtonAccess(
                            "contest.fullContestList.other"
                          )) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/contests/board"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Contest's Board
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/contests/board"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Layout/Layout-4-blocks.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Contest's Board
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}{" "}
                        {/* {helperFunc.isMenuShow("contestAssign") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/contest/hackers"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Contest's Hackers
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/contest/hackers"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Contest's Hackers
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )} */}
                        {/* <li
                          className={`menu-item  ${getMenuItemActive(
                            "/contest/settings"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                Contest's Settings - Cancellation
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/contest/settings"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Add-user.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                Contest's Settings - Cancellation
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li> */}
                        {/* <li
                          className={`menu-item  ${getMenuItemActive(
                            "/contest/report"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                Report
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/contest/report"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Add-user.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                Report
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li> */}
                      </ul>
                    </div>
                  </li>
                )}
                {/* scrims */}
                {(helperFunc.isButtonAccess("scrim.scrims.list") ||
                  helperFunc.isButtonAccess("scrim.hostReports.list") ||
                  helperFunc.isButtonAccess("scrim.scrimReports.list") ||
                  helperFunc.isButtonAccess(
                    "scrim.scrimTransactionsReports.list"
                  ) ||
                  helperFunc.isButtonAccess("scrim.gamesReports.list")) && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">Private Scrim's</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/scrims"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Shopping/Settings.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Private Scrim's </span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>

                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {/* {helperFunc.isPageAccess("contestTypes") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/contest-types/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Contest's Type
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/contest-types/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Clipboard-list.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Contest's Type <i className='flaticon2-check-mark text-success ml-2 font-size-lg'></i></span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}{" "} */}
                        {helperFunc.isButtonAccess("scrim.scrims.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/scrims/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Private Scrims's List
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/scrims/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Shopping/Settings.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Private Scrim's List{" "}
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {/* scrim's report */}
                        {helperFunc.isButtonAccess(
                          "scrim.hostReports.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/reports/HostReport"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="download-report">
                                  Host Report's
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/reports/HostReport"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Clipboard-list.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Host Report's</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess(
                          "scrim.scrimReports.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/reports/ScrimsReport"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="download-report">
                                  Private Scrim Report's
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/reports/ScrimsReport"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Clipboard-list.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Private Scrim Report's
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess(
                          "scrim.scrimTransactionsReports.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/reports/ScrimTransactionReport"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="download-report">
                                  Private Scrim Transaction Report's
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/reports/ScrimTransactionReport"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Clipboard-list.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Private Scrim Transaction Report's
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess(
                          "scrim.gamesReports.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/reports/GamewiseReport"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="download-report">
                                  Game wise Report's
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/reports/GamewiseReport"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Clipboard-list.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Game wise Report's
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {/* scrim's report */}
                      </ul>
                    </div>
                  </li>
                )}

                {/* Subscription */}
                {(helperFunc.isButtonAccess("subscription.pack.add") ||
                  helperFunc.isButtonAccess(
                    "subscription.subscriptions.list"
                  ) ||
                  helperFunc.isButtonAccess(
                    "subscription.subscriptionUser.list"
                  ) ||
                  helperFunc.isButtonAccess("subscription.settings.add")) && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">Subscription's</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/subscription"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Shopping/Settings.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Subscription </span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>

                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {/* {helperFunc.isButtonAccess("subscription.pack.add") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/subscription/addsubscriptionpack"
                            )}`}
                            onClick={() => window.location.reload()} // Added a closing parenthesis here
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Add Subscription Pack
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/subscription/addsubscriptionpack"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Shopping/Settings.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Add Subscription Pack
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )} */}
                        {/* <li
                              className={`menu-item  ${getMenuItemActive(
                                "/subscription/addsubscriptionpack"
                              )}`}
                              aria-haspopup="true"
                            >
                              <OverlayTrigger
                                placement="right"
                                overlay={
                                  <Tooltip id="latest-reports">
                                    Add Subscription Pack
                                  </Tooltip>
                                }
                              >
                                <Link
                                  to={"/subscription/addsubscriptionpack"}
                                  className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                  role="tab"
                                >
                                  <span className="svg-icon svg-icon-lg menu-icon">
                                    <SVG
                                      src={toAbsoluteUrl(
                                        "/media/svg/icons/Shopping/Settings.svg"
                                      )}
                                    />
                                  </span>
                                  <span className="menu-text">
                                    Add Subscription Pack{" "}
                                  </span>
                                </Link>
                              </OverlayTrigger>
                            </li> */}

                        {helperFunc.isButtonAccess(
                          "subscription.subscriptions.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/subscription/subscriptionlist"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Subscription List
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/subscription/subscriptionlist"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Shopping/Settings.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Subscription List{" "}
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}

                        {helperFunc.isButtonAccess(
                          "subscription.subscriptionUser.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/subscription/subscriptionUserlist"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Subscription User List
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/subscription/subscriptionUserlist"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Shopping/Settings.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Subscription User List{" "}
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}

                        {helperFunc.isButtonAccess(
                          "subscription.settings.add"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/subscription/subscriptionsetting"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Subscription Setting
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/subscription/subscriptionsetting"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Shopping/Settings.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Subscription Setting{" "}
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {/* Subscription */}
                      </ul>
                    </div>
                  </li>
                )}
                {/* Download Ads */}
                {(helperFunc.isButtonAccess(
                  "downloadAds.adsCompanyList.list"
                ) ||
                  helperFunc.isButtonAccess(
                    "downloadAds.companyReports.list"
                  ) ||
                  helperFunc.isButtonAccess("downloadAds.adsReports.list") ||
                  helperFunc.isButtonAccess("downloadAds.adsPosition.add")) && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">Download Ads</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/DownloadAdscompanylist"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Shopping/Settings.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Download Ads </span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>

                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {helperFunc.isButtonAccess(
                          "downloadAds.adsCompanyList.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/DownloadAdscompanylist/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="adscompany-reports">
                                  Ads Company List
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/DownloadAdscompanylist/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Shopping/Settings.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Ads Company List{" "}
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}

                        {helperFunc.isButtonAccess(
                          "downloadAds.companyReports.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/reports/CompanyReport"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="download-report">
                                  Company Report's
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/reports/CompanyReport"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Clipboard-list.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Company Report's
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}

                        {helperFunc.isButtonAccess(
                          "downloadAds.adsReports.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/reports/AdsReport"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="download-report">
                                  {" "}
                                  Ads Report's
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/reports/AdsReport"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Clipboard-list.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text"> Ads Report's</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}

                        {/* ads position */}

                        {helperFunc.isButtonAccess(
                          "downloadAds.adsPosition.add"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/reports/AdsPosition"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="download-report">
                                  {" "}
                                  Ads Position
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/reports/AdsPosition"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Clipboard-list.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text"> Ads Position</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                      </ul>
                    </div>
                  </li>
                )}
                {/* Time Slot List */}
                {helperFunc.isButtonAccess("timesolts.timeSlotList.list") && (
                  <li
                    className={`menu-item  ${getMenuItemActive(
                      "/time-slot/list"
                    )}`}
                    aria-haspopup="true"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-reports">Time Slot List</Tooltip>
                      }
                    >
                      <Link
                        to={"/time-slot/list"}
                        className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                        role="tab"
                      >
                        <span className="svg-icon svg-icon-lg menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Shopping/Settings.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Time Slot List </span>
                      </Link>
                    </OverlayTrigger>
                  </li>
                )}
                {/* tournaments */}
                {(helperFunc.isButtonAccess(
                  "tournament.openTournaments.list"
                ) ||
                  helperFunc.isButtonAccess(
                    "tournament.closeTournaments.list"
                  ) ||
                  helperFunc.isButtonAccess(
                    "tournament.assignTournaments.list"
                  ) ||
                  helperFunc.isButtonAccess("tournament.openTournaments.add") ||
                  helperFunc.isButtonAccess(
                    "tournament.closeTournaments.add"
                  )) && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">Tournaments</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/tournaments"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/General/Settings-2.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Tournaments</span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>

                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {(helperFunc.isButtonAccess(
                          "tournament.openTournaments.add"
                        ) ||
                          helperFunc.isButtonAccess(
                            "tournament.closeTournaments.add"
                          )) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/tournaments/add"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Add Tournament
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/tournaments/add"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Home/Picture.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Add Tournament
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {(helperFunc.isButtonAccess(
                          "tournament.openTournaments.list"
                        ) ||
                          helperFunc.isButtonAccess(
                            "tournament.closeTournaments.list"
                          )) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/tournaments/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Tournament List
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/tournaments/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Shopping/Settings.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Tournament List{" "}
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess(
                          "tournament.assignTournaments.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/tournaments/contest-assign/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Assign / Reassign Tournament's
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/tournaments/contest-assign/create"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Tournament Assign
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess(
                          "tournament.assignTournaments.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/contest-assign/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Assign / Reassign Tournament's
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/tournaments/contest-assign/reassign"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Tournament Re-Assign
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                      </ul>
                    </div>
                  </li>
                )}
                {/* colleges */}
                {helperFunc.isButtonAccess("colleges.college.list") && (
                  <li
                    className={`menu-item mb-3 ${getMenuItemActive(
                      "/colleges"
                    )}`}
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={<Tooltip id="latest-project">Colleges</Tooltip>}
                    >
                      <Link
                        className="menu-link nav-link btn btn-icon btn-clean btn-lg my-menu-item"
                        to="/colleges"
                      >
                        <span className="svg-icon svg-icon-lg menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Clothes/Shirt.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Colleges</span>
                      </Link>
                    </OverlayTrigger>
                  </li>
                )}
                {/* h5 games */}
                {(helperFunc.isButtonAccess("html5Games.categories.list") ||
                  helperFunc.isButtonAccess("html5Games.gamesList.list") ||
                  helperFunc.isButtonAccess("html5Games.joiningList.list") ||
                  helperFunc.isButtonAccess(
                    "html5Games.gameWiseJoining.list"
                  ) ||
                  helperFunc.isButtonAccess("html5Games.categories.list") ||
                  helperFunc.isButtonAccess("html5Games.settings.add")) && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">HTML5 Games</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/html5"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Devices/Gamepad1.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">HTML5 Games</span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>

                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {helperFunc.isButtonAccess(
                          "html5Games.categories.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/html5-categories"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Categories
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/html5-categories"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Clipboard-list.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Categories</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}{" "}
                        {helperFunc.isButtonAccess(
                          "html5Games.gamesList.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/H5Games"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Game's List
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/H5Games"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Devices/Gamepad1.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Game's List</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}{" "}
                        {helperFunc.isButtonAccess(
                          "html5Games.joiningList.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/H5Games/joining-list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Joining List's
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/H5Games/joining-list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Devices/Gamepad1.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Joining List's
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}{" "}
                        {helperFunc.isButtonAccess(
                          "html5Games.gameWiseJoining.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/H5Games/game-wise-joining-list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Gamewise Joining List
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/H5Games/game-wise-joining-list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Devices/Gamepad1.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Gamewise Joining List
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}{" "}
                        {helperFunc.isButtonAccess(
                          "html5Games.settings.add"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/H5Games/setting"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">Settings</Tooltip>
                              }
                            >
                              <Link
                                to={"/H5Games/setting"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/General/Settings-2.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Settings</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                      </ul>
                    </div>
                  </li>
                )}
                {/* transaction */}
                {helperFunc.isButtonAccess("transaction.contest.list") && (
                  <li
                    className={`menu-item  ${getMenuItemActive(
                      "/transactions"
                    )}`}
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">Transactions</Tooltip>
                      }
                    >
                      <Link
                        className="menu-link nav-link btn btn-icon btn-clean btn-lg my-menu-item"
                        to="/transactions"
                      >
                        <span className="svg-icon svg-icon-lg menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Layout/Layout-4-blocks.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Transactions</span>
                      </Link>
                    </OverlayTrigger>
                  </li>
                )}
                {/* Finshell Reports */}
                {helperFunc.isButtonAccess("finshell.dashboard.list") && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">Finshell Reports</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/finshellDashboard"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Shopping/Settings.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Finshell Reports </span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>

                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {helperFunc.isButtonAccess(
                          "finshell.dashboard.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/finshellDashboard"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Finshell Dashboard
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/finshellDashboard"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Finshell Dashboard
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                      </ul>
                    </div>
                  </li>
                )}
                {/* Easypaisa Transactions */}
                {/* {(helperFunc.isButtonAccess("easypaisa.dashboard.list") ||
                  helperFunc.isButtonAccess(
                    "easypaisa.contestReport.list"
                  )) && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">Easypaisa Reports</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/easyPaisaDashboard/list"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Shopping/Settings.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Easypaisa Reports </span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>

                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {helperFunc.isButtonAccess(
                          "easypaisa.dashboard.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/easyPaisaDashboard/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Easypaisa Dashboard
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/easyPaisaDashboard/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Easypaisa Dashboard
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess(
                          "easypaisa.contestReport.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/easyPaisaDashboard/contestReport"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Easypaisa Contest Report
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/easyPaisaDashboard/contestReport"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Easypaisa Contest Report
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                      </ul>
                    </div>
                  </li>
                )} */}
                {/* Xiaomi Reports */}
                {(helperFunc.isButtonAccess("xiaomi.dashboard.list") ||
                  helperFunc.isButtonAccess("xiaomi.contestReport.list")) && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">Xiaomi Reports</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/xiaomiDashboard/list"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Shopping/Settings.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Xiaomi Reports </span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>

                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {helperFunc.isButtonAccess(
                          "xiaomi.dashboard.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/xiaomiDashboard/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Xiaomi Dashboard
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/xiaomiDashboard/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Xiaomi Dashboard
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess(
                          "xiaomi.contestReport.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/xiaomiDashboard/contestReport"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Xiaomi Contest Report
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/xiaomiDashboard/contestReport"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                 Xiaomi Contest Report
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                      </ul>
                    </div>
                  </li>
                )}
                {/* GoPlay Reports */}
                {/* {(helperFunc.isButtonAccess("goplay.dashboard.list") ||
                  helperFunc.isButtonAccess("goplay.contestReport.list")) && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">GoPlay Reports</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/goPlayDashboard/list"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Shopping/Settings.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">GoPlay Reports </span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>

                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/goPlayDashboard/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  GoPlay Dashboard
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/goPlayDashboard/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  GoPlay Dashboard
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        }
                      </ul>
                    </div>
                  </li>
                )} */}
                {/* Ampere Reports */}
                {/* {(helperFunc.isButtonAccess("ampere.dashboard.list") ||
                  helperFunc.isButtonAccess("ampere.contestReport.list")) && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">Ampere Reports</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/ampereDashboard/list"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Shopping/Settings.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Ampere Reports </span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>

                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {
                          // helperFunc.isButtonAccess("goplay.dashboard.list") &&
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/ampereDashboard/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Ampere Dashboard
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/ampereDashboard/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Ampere Dashboard
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        }
                     
                      </ul>
                    </div>
                  </li>
                )} */} 
                {/* Jazz Reports */}
                {/* {helperFunc.isButtonAccess("jazz.dashboard.list") && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">Jazz Reports</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/jazzDashboard/list"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Shopping/Settings.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Jazz Reports </span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>

                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {helperFunc.isButtonAccess("jazz.dashboard.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/jazzDashboard/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Jazz Dashboard
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/jazzDashboard/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Jazz Dashboard
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                      </ul>
                    </div>
                  </li>
                )} */}
                {/* Mobily Reports */}
                {/* {helperFunc.isButtonAccess("mobily.dashboard.list") && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">Mobily Reports</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/mobilyDashboard/list"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Shopping/Settings.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Mobily Reports </span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>

                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {helperFunc.isButtonAccess("mobily.dashboard.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/mobilyDashboard/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Mobily Dashboard
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/mobilyDashboard/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Mobily Dashboard
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                      </ul>
                    </div>
                  </li>
                )} */}
                {/* Gamerji Reports */}
                {/* {(helperFunc.isButtonAccess("gamerji.dashboard.list") ||
                  helperFunc.isButtonAccess("gamerji.banneradslog.list")) && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">Gamerji Reports</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/gamerjiDashboard/list"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Shopping/Settings.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Gamerji Reports </span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>

                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {helperFunc.isButtonAccess(
                          "gamerji.dashboard.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/gamerjiDashboard/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Gamerji Dashboard
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/gamerjiDashboard/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Gamerji Dashboard
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                      </ul>
                    </div>
                    
                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {helperFunc.isButtonAccess(
                          "gamerji.banneradslog.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/gamerjiDashboard/bannerloglist"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Banner Ads - Logs
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/gamerjiDashboard/bannerloglist"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Banner Ads - Logs
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                           {helperFunc.isButtonAccess("vi.dashboard.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/gamerjiDashboard/SubscriptionTransaction/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Gamerji Subscription Transaction
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/gamerjiDashboard/SubscriptionTransaction/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Gamerji Subscription Transaction
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}

                        {helperFunc.isButtonAccess("vi.dashboard.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/gamerjiDashboard/CoinStoreTransaction/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Coin Store Transaction
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/gamerjiDashboard/CoinStoreTransaction/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Coin Store Transaction
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}

                        {helperFunc.isButtonAccess("vi.dashboard.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/gamerjiDashboard/TournamnetTransaction/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Tournamnet Transaction
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/gamerjiDashboard/TournamnetTransaction/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Tournamnet Transaction
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess("vi.dashboard.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/gamerjiDashboard/ContestTransaction/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Contest Transaction
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/gamerjiDashboard/ContestTransaction/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Contest Transaction
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                      </ul>
                      
                    </div>
                  </li>
                )} */}
                {/* Safaricom Reports */}
                {/* {helperFunc.isButtonAccess("safaricom.dashboard.list") && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/safaricomDashboard"
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">Safaricom Reports</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/safaricomDashboard"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/General/Like.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Safaricom Reports</span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>
                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                      
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/safaricomDashboard/list"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                Safaricom Dashboard
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/safaricomDashboard/list"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/General/Like.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                Safaricom Dashboard
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                     
                      </ul>
                    </div>
                  </li>
                )} */}
                {/* Talabat Reports */}
                {/* {helperFunc.isButtonAccess("talabat.dashboard.list") && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/talabatDashboard"
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">Talabat Reports</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/talabatDashboard"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/General/Like.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Talabat Reports</span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>
                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                  
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/talabatDashboard/list"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                Talabat Dashboard
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/talabatDashboard/list"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/General/Like.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                Talabat Dashboard
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                       
                      </ul>
                    </div>
                  </li>
                )} */}
                {/* BISB Reports */}
                {/* {helperFunc.isButtonAccess("bisb.dashboard.list") && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/bisbDashboard"
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">BISB Reports</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/bisbDashboard"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/General/Like.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">BISB Reports</span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>
                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                      
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/bisbDashboard/list"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                BISB Dashboard
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/bisbDashboard/list"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/General/Like.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">BISB Dashboard</span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                     
                      </ul>
                    </div>
                  </li>
                )} */}
                {/* Indigg Reports */}
                {helperFunc.isButtonAccess("indgg.dashboard.list") && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/indggDashboard"
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">Indigg Reports</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/indggDashboard"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/General/Like.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Indigg Reports</span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>
                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {/* {helperFunc.isButtonAccess(
                          "advertisers.advertisers.list"
                        ) && ( */}
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/indggDashboard/list"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                Indigg Dashboard
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/indggDashboard/list"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/General/Like.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                Indigg Dashboard
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                        {/* )} */}
                      </ul>
                    </div>
                  </li>
                )}
                {/* Ooredoo Reports */}
                {/* {helperFunc.isButtonAccess("ooredoo.dashboard.list") && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/ooredooDashboard"
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">Ooredoo Reports</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/ooredooDashboard"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/General/Like.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Ooredoo Reports</span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>
                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                      
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/ooredooDashboard/list"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                Ooredoo Dashboard
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/ooredooDashboard/list"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/General/Like.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">
                                Ooredoo Dashboard
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                     
                      </ul>
                    </div>
                  </li>
                )} */}
                {/* GLO Reports */}
                {/* {helperFunc.isButtonAccess("glo.dashboard.list") && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/gloDashboard"
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">GLO Reports</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/gloDashboard"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/General/Like.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">GLO Reports</span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>
                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                     
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/gloDashboard/list"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">
                                GLO Dashboard
                              </Tooltip>
                            }
                          >
                            <Link
                              to={"/gloDashboard/list"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/General/Like.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">GLO Dashboard</span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                      
                      </ul>
                    </div>
                  </li>
                )} */}
                {/* D11 Reports */}
                {/* {helperFunc.isButtonAccess("d11.dashboard.list") && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">D11 Reports</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/d11Dashboard/list"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Shopping/Settings.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">D11 Reports </span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>

                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {helperFunc.isButtonAccess("d11.dashboard.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/d11Dashboard/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  D11 Dashboard
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/d11Dashboard/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">D11 Dashboard</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                      </ul>
                    </div>
                  </li>
                )} */}
                {/* Vodafone Reports */}
                {/* {helperFunc.isButtonAccess("vi.dashboard.list") && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">Vodafone Reports</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/viDashboard/list"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Shopping/Settings.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Vodafone Reports </span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>

                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {helperFunc.isButtonAccess("vi.dashboard.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/viDashboard/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Vodafone Dashboard
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/viDashboard/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Vodafone Dashboard
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}

                        {helperFunc.isButtonAccess("vi.dashboard.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/viDashboard/SubscriptionTransaction/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Vodafone Subscription Transaction
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/viDashboard/SubscriptionTransaction/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Vodafone Subscription Transaction
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}

                        {helperFunc.isButtonAccess("vi.dashboard.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/viDashboard/CoinStoreTransaction/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Coin Store Transaction
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/viDashboard/CoinStoreTransaction/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Coin Store Transaction
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}

                        {helperFunc.isButtonAccess("vi.dashboard.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/viDashboard/TournamnetTransaction/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Tournamnet Transaction
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/viDashboard/TournamnetTransaction/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Tournamnet Transaction
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess("vi.dashboard.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/viDashboard/ContestTransaction/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Contest Transaction
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/viDashboard/ContestTransaction/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Contest Transaction
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                      </ul>
                    </div>
                  </li>
                )} */}
                {/* Real11 Reports */}
                {/* {helperFunc.isButtonAccess("r11.dashboard.list") && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">Real11 Reports</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/r11Dashboard/list"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Shopping/Settings.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Real11 Reports </span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>

                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {helperFunc.isButtonAccess(
                          "r11.contestReport.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/r11Dashboard/ContestReport"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Real11 Contest Report
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/r11Dashboard/ContestReport"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Reall1 Contest Report
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                      </ul>
                    </div>
                  </li>
                )} */}
                {/* Company */}
                {helperFunc.isButtonAccess("company.company.get") && (
                  <li className={`menu-item  ${getMenuItemActive("/company")}`}>
                    <OverlayTrigger
                      placement="right"
                      overlay={<Tooltip id="latest-project">Company</Tooltip>}
                    >
                      <Link
                        className="menu-link nav-link btn btn-icon btn-clean btn-lg my-menu-item"
                        to="/company"
                      >
                        <span className="svg-icon svg-icon-lg menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Layout/Layout-4-blocks.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Company</span>
                      </Link>
                    </OverlayTrigger>
                  </li>
                )}
                {/* rewards */}
                {(helperFunc.isButtonAccess("reward.rewardsCategory.list") ||
                  helperFunc.isButtonAccess("reward.rewardsProduct.update") ||
                  helperFunc.isButtonAccess("reward.rewardsLiveProduct.list") ||
                  helperFunc.isButtonAccess(
                    "reward.rewardsTransaction.list"
                  )) && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={<Tooltip id="latest-project">Rewards</Tooltip>}
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/rewards"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/General/Settings-2.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Rewards</span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>

                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {/* {helperFunc.isButtonAccess(
                            "reward.dailyRewards.list"
                          ) && (
                              <li
                                className={`menu-item  ${getMenuItemActive(
                                  "/dailyLogin-rewards/list"
                                )}`}
                                aria-haspopup="true"
                              >
                                <OverlayTrigger
                                  placement="right"
                                  overlay={
                                    <Tooltip id="dailyLogin-reports">
                                      Daily Login Rewards
                                    </Tooltip>
                                  }
                                >
                                  <Link
                                    to={"/dailyLogin-rewards/list"}
                                    className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                    role="tab"
                                  >
                                    <span className="svg-icon svg-icon-lg menu-icon">
                                      <SVG
                                        src={toAbsoluteUrl(
                                          "/media/svg/icons/Shopping/Money.svg"
                                        )}
                                      />
                                    </span>
                                    <span className="menu-text">Daily Login Rewards</span>
                                  </Link>
                                </OverlayTrigger>
                              </li>
                            )} */}
                        {helperFunc.isButtonAccess(
                          "reward.dailyRewards.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/reward/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Daily Rewards
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/reward/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Shopping/Money.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Daily Rewards</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess(
                          "reward.rewardsCategory.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/rewards/categories"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Rewards Categories
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/rewards/categories"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Home/Picture.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Rewards Categories
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess(
                          "reward.rewardsProduct.update"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/rewards/products"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Reward Products
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/rewards/products"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Home/Picture.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Reward Products
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess(
                          "reward.rewardsLiveProduct.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/rewards/live-products"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Reward Live Products
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/rewards/live-products"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Home/Picture.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Reward Live Products
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess(
                          "reward.rewardsTransaction.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/rewards/transaction"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Rewards Transaction
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/rewards/transaction"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Home/Picture.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Rewards Transaction
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}

                        {/* <li
                          className={`menu-item  ${getMenuItemActive(
                            "/reward/unique-user"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">Reward's Unique User's List</Tooltip>
                            }
                          >
                            <Link
                              to={"/reward/unique-user"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Home/Picture.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">Reward's Unique User's List</span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/reward/stats"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">Stats</Tooltip>
                            }
                          >
                            <Link
                              to={"/reward/stats"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Home/Picture.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">Stats</span>
                            </Link>
                          </OverlayTrigger>
                        </li> */}
                      </ul>
                    </div>
                  </li>
                )}
                {/* coupon */}
                {(helperFunc.isButtonAccess("coupons.couponCategories.list") ||
                  helperFunc.isButtonAccess("coupons.coupons.list")) && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={<Tooltip id="latest-project">Coupons</Tooltip>}
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/coupons"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Shopping/Ticket.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Coupons</span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>

                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {helperFunc.isButtonAccess(
                          "coupons.couponCategories.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/coupon-categories"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Coupons's Categories
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/coupon-categories"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Clipboard-list.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Coupons's Categories
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}{" "}
                        {helperFunc.isButtonAccess("coupons.coupons.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/coupons"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">Coupons</Tooltip>
                              }
                            >
                              <Link
                                to={"/coupons"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Clipboard-list.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Coupons</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}{" "}
                        {/* {helperFunc.isMenuShow("coupons") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/coupons/signup"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">Signup Coupons</Tooltip>
                              }
                            >
                              <Link
                                to={"/coupons/signup"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Shopping/Ticket.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Signup Coupons</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/coupons/promo"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">Promo Coupons</Tooltip>
                            }
                          >
                            <Link
                              to={"/coupons/promo"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Shopping/Ticket.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">Promo Coupons</span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/coupons/cashback"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">Cashback Coupons</Tooltip>
                            }
                          >
                            <Link
                              to={"/coupons/cashback"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Shopping/Ticket.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">Cashback Coupons</span>
                            </Link>
                          </OverlayTrigger>
                        </li>
                        <li
                          className={`menu-item  ${getMenuItemActive(
                            "/coupons/stats"
                          )}`}
                          aria-haspopup="true"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="latest-reports">Stats</Tooltip>
                            }
                          >
                            <Link
                              to={"/coupons/stats"}
                              className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                              role="tab"
                            >
                              <span className="svg-icon svg-icon-lg menu-icon">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Shopping/Ticket.svg"
                                  )}
                                />
                              </span>
                              <span className="menu-text">Stats</span>
                            </Link>
                          </OverlayTrigger>
                        </li> */}
                      </ul>
                    </div>
                  </li>
                )}
                {/* Master */}
                {(helperFunc.isButtonAccess("master.currency.get") ||
                  helperFunc.isButtonAccess("master.apkScreen.list") ||
                  helperFunc.isButtonAccess("master.countries.list")) && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={<Tooltip id="latest-project">Master</Tooltip>}
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/customer-care"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/General/Settings-2.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Master</span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>

                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {helperFunc.isButtonAccess("master.countries.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/countries"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">Countries</Tooltip>
                              }
                            >
                              <Link
                                to={"/countries"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Flag.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Countries</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}

                        {helperFunc.isButtonAccess("master.states.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/states"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">States</Tooltip>
                              }
                            >
                              <Link
                                to={"/states"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Flag.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">States</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess("master.cities.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/cities"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">Cities</Tooltip>
                              }
                            >
                              <Link
                                to={"/cities"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Flag.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Cities</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}

                        {helperFunc.isButtonAccess("master.currency.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/currencies/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">Currency</Tooltip>
                              }
                            >
                              <Link
                                to={"/currencies/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Home/Picture.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Currency</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess("master.apkScreen.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/apkscreen/list"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  APK Screens
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/apkscreen/list"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Home/Picture.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">APK Screen</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}

                        {helperFunc.isButtonAccess("master.languages.list") && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/languages"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">Languages</Tooltip>
                              }
                            >
                              <Link
                                to={"/languages"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Communication/Flag.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Languages</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                      </ul>
                    </div>
                  </li>
                )}
                {/* Customer Care*/}
                {(helperFunc.isButtonAccess(
                  "coustomercare.issueCategory.list"
                ) ||
                  helperFunc.isButtonAccess("coustomercare.tickets.list")) && (
                  <li
                    className={`menu-item menu-item-submenu`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">Customer Care</Tooltip>
                      }
                    >
                      <NavLink
                        className="menu-link menu-toggle my-menu-item"
                        to="/customer-care"
                      >
                        <span className="svg-icon menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/General/Settings-2.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Customer Care</span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </OverlayTrigger>
                    <div className="menu-submenu ">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        {helperFunc.isButtonAccess(
                          "coustomercare.issueCategory.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/issue-categories"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">
                                  Issue Categories
                                </Tooltip>
                              }
                            >
                              <Link
                                to={"/issue-categories"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Home/Picture.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">
                                  Issue Categories
                                </span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                        {helperFunc.isButtonAccess(
                          "coustomercare.tickets.list"
                        ) && (
                          <li
                            className={`menu-item  ${getMenuItemActive(
                              "/ticket"
                            )}`}
                            aria-haspopup="true"
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="latest-reports">Tickets</Tooltip>
                              }
                            >
                              <Link
                                to={"/ticket"}
                                className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                                role="tab"
                              >
                                <span className="svg-icon svg-icon-lg menu-icon">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Home/Picture.svg"
                                    )}
                                  />
                                </span>
                                <span className="menu-text">Tickets</span>
                              </Link>
                            </OverlayTrigger>
                          </li>
                        )}
                      </ul>
                    </div>
                  </li>
                )}
                {/* leaderboard */}
                {helperFunc.isButtonAccess("leaderboard.list") && (
                  <li
                    className={`menu-item  ${getMenuItemActive(
                      "/leader-board/list"
                    )}`}
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">Leaderboard</Tooltip>
                      }
                    >
                      <Link
                        className="menu-link nav-link btn btn-icon btn-clean btn-lg my-menu-item"
                        to="/leader-board/list"
                      >
                        <span className="svg-icon svg-icon-lg menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Layout/Layout-4-blocks.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Leaderboard</span>
                      </Link>
                    </OverlayTrigger>
                  </li>
                )}
                {/* CMS */}
                {helperFunc.isButtonAccess("cms.page.list") && (
                  <li
                    className={`menu-item  ${getMenuItemActive(
                      "/cms/company"
                    )}`}
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">
                          Cms setting by company
                        </Tooltip>
                      }
                    >
                      <Link
                        className="menu-link nav-link btn btn-icon btn-clean btn-lg my-menu-item"
                        to="/cms"
                      >
                        <span className="svg-icon svg-icon-lg menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Layout/Layout-4-blocks.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Cms Setting</span>
                      </Link>
                    </OverlayTrigger>
                  </li>
                )}
                {(helperFunc.isButtonAccess("notification.email.list") ||
                  helperFunc.isButtonAccess("notification.push.list")) && (
                  <li
                    className={`menu-item  ${getMenuItemActive(
                      "/notifications"
                    )}`}
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-project">Notifications</Tooltip>
                      }
                    >
                      <Link
                        className="menu-link nav-link btn btn-icon btn-clean btn-lg my-menu-item"
                        to="/notifications"
                      >
                        <span className="svg-icon svg-icon-lg menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Layout/Layout-4-blocks.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Notifications</span>
                      </Link>
                    </OverlayTrigger>
                  </li>
                )}
                {helperFunc.isButtonAccess("coinstore.coinStore.list") && (
                  <li
                    className={`menu-item ${getMenuItemActive("/coin-stores")}`}
                    aria-haspopup="true"
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="latest-reports">Coin Stores</Tooltip>
                      }
                    >
                      <Link
                        to={"/coin-stores"}
                        className="menu-link nav-link btn btn-icon btn-clean btn-lg"
                        role="tab"
                      >
                        <span className="svg-icon svg-icon-lg menu-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Design/Circle.svg"
                            )}
                          />
                        </span>
                        <span className="menu-text">Coin Stores</span>
                      </Link>
                    </OverlayTrigger>
                  </li>
                )}
              </ul>
            </div>
          </div>
          {/* end::Nav Wrapper */}
          {/* begin::Footer */}
          <div className="aside-footer flex-column align-items-center flex-column-auto py-4 py-lg-1 d-inline">
            {/* begin::Quick Actions */}
            {layoutProps.extrasQuickActionsDisplay && (
              <OverlayTrigger
                placement="right"
                overlay={
                  <Tooltip id="toggle-quick-actions">Quick Actions</Tooltip>
                }
              >
                <a
                  href="#"
                  className="btn btn-icon btn-clean btn-lg mb-1"
                  id="kt_quick_actions_toggle"
                >
                  <span className="svg-icon svg-icon-lg menu-icon">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Media/Equalizer.svg"
                      )}
                    />
                  </span>
                </a>
              </OverlayTrigger>
            )}
            {/* end::Quick Actions */}
            {/* begin::Quick Panel */}
            {layoutProps.extrasQuickPanelDisplay && (
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="toggle-quick-panel">Quick Panel</Tooltip>}
              >
                <a
                  href="#"
                  className="btn btn-icon btn-clean btn-lg mb-1 position-relative"
                  id="kt_quick_panel_toggle"
                  data-placement="right"
                  data-container="body"
                  data-boundary="window"
                >
                  <span className="svg-icon svg-icon-lg menu-icon">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Layout/Layout-4-blocks.svg"
                      )}
                    />
                  </span>
                  <span className="label label-sm label-light-danger label-rounded font-weight-bolder position-absolute top-0 right-0 mt-1 mr-1">
                    3
                  </span>
                </a>
              </OverlayTrigger>
            )}
            {/* end::Quick Panel */}
            {/* begin::Languages*/}
            {layoutProps.extrasLanguagesDisplay && <LanguageSelectorDropdown />}
            {/* end::Languages */}
            {/* begin::User*/}
            {layoutProps.extrasUserDisplay && <QuickUserToggler />}
            {/* end::User */}
          </div>
          {/* end::Footer */}
        </div>
        {/* end::Primary */}
        {layoutProps.asideSecondaryDisplay && <></>}
      </div>
      {/* end::Aside */}
    </>
  );
}
